/// <amd-module name="SearchUI/Components/PathSelector/PathSelector.Props" />
export enum PathApplicationMode {
    allowAll,

    allowOnlyValid
}

export enum ContentLoadState {
    Loading,
    LoadSuccess,
    LoadFailed
}

export enum Mode {
    None = 0x0,

    Searching = 0x1,

    Navigating = 0x2,
}

export interface IPathSelectorBehaviour {
    pathApplicationMode: PathApplicationMode;

    getPath: (item: any) => string;

    onItemRender: (item: any, hitText: string, highlight: boolean) => JSX.Element;

    getItemsOnActivation: (items: any[], textBoxInput: string) => any[];

    getActivatedItemIndexOnActivation: (items: any[], textBoxInput: string) => number;
}

export interface IPathSelectorProps {
    /**
     * A unique string which represents the Path selector control.
     */
    name: string;

    /**
     * True when the control is enabled, false otherwise.
     */
    enabled: boolean;

    /**
     * The list of item shown in the drop-down menu.
     */
    items: any[];

    /**
     * The left hand side part of full string labelled as button text.
     */
    label: string;

    /**
    * Defines behavior such as the item renderer, items to be shown when activated etc.
    */
    behaviour: IPathSelectorBehaviour;

    /**
    * Defines whether the content load has finished, is in progress, or failed.
    */
    contentLoadState: ContentLoadState;

    /**
    * Aria label for clear text icon in the search box.
    */
    searchBoxClearTextAriaLabel: string;

    /**
    * Aria label for apply path button.
    */
    applyButtonAriaLabel: string;

    /**
     * Water mark text of the search box rendered when the control supports search in the list.
     */
    searchTextPlaceholder?: string;

    /** 
    * Initially selected menu item
    */
    defaultSelectedItem?: any,

    /**
      * Delegate invoked whenever item selection happens.
     */
    onSelectionChanged?: (name: string, path: string) => void;

    /**
    * Deletegate invoked to get the JSX Element to be displayed in the footer section of the drop-down menu.
    */
    onGetFooterMessage?: (itemCount: number, searchText: string, mode: Mode) => JSX.Element;

    /**
     * Delegate invoked on user action e.g. hover on help icon to trigger callout.
     */
    triggerCallout?: (showCallout: boolean) => void;

    /**
     * Object to hold callout properties such as the title, and content.
     */
    calloutProps?: { [key: string]: string };

    /**
     * Method to invoke on Click on filter
     */
    onClick?: () => void;
}

export interface IPathSelectorMenuProps {
    /**
     * Unique Id for the drop-down.
     */
    id: string;

    /**
     * The list of item shown in the drop-down menu.
     */
    items: any[];

    /**
     * The index of the item in the list to be highlighted.
     */
    currentItemIndex: number;

    /**
    * JSX element to be displayed in the footer section of the drop-down menu.
    */
    footerMessageElement: JSX.Element;

    /**
     * Delegate invoked to render a particular item in the drop down.
     */
    onItemRender: (item: any) => JSX.Element;

    /**
     * Delegate invoked when an item in the list is clicked.
     */
    onItemClick: (item: any) => void;
}